var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVolumeMiddle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.58078 4.43141C10.0595 3.9832 10.4519 4.13528 10.4519 4.76929V19.2305C10.4519 19.8647 10.0595 20.0168 9.58078 19.5684L5.07417 15.3535H2.08696V8.64685H5.07417L9.58078 4.43141ZM12.3382 16.0001C12.1089 16.0001 11.8792 15.9185 11.7039 15.7546C11.3537 15.427 11.3537 14.896 11.7039 14.569C13.218 13.1527 13.218 10.8484 11.7039 9.43217C11.3537 9.10463 11.3537 8.57368 11.7039 8.24653C12.0541 7.91937 12.6216 7.91937 12.9714 8.24653C15.1846 10.3171 15.1846 13.6852 12.9714 15.7553C12.7969 15.9178 12.5676 16.0001 12.3382 16.0001ZM15.5216 17.5808C15.2919 17.5808 15.0625 17.4991 14.8872 17.3353C14.5374 17.0076 14.5374 16.4767 14.8872 16.1495C17.3334 13.8617 17.3334 10.139 14.8872 7.85119C14.5374 7.52365 14.5374 6.9927 14.8872 6.66555C15.2374 6.33801 15.805 6.33801 16.1547 6.66555C17.6787 8.08984 18.5178 9.98495 18.5178 12C18.5178 14.0155 17.6787 15.91 16.1551 17.3353C15.9804 17.4991 15.751 17.5808 15.5216 17.5808Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVolumeMiddle);
export default __webpack_public_path__ + "static/media/volume-middle.fb134c251ea196d5dfd929b22ddf1326.svg";
export { ForwardRef as ReactComponent };